<template>
  <div class="upload-reports">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-CC" fill="#fff"></use>
      </svg>
    </breadcrumbs>
    <div class="content-wrapper">
      <div class="table-head">
        <a-space>
          <ButtonGroups :pagination="{
            total: params.total,
            page: params.page,
            size: params.size,
          }" :tableData="dataSource" @pageChange="onPageChange" />
        </a-space>
        <a-space>
          <a-input-search v-model:value="filter.keyword" placeholder="Search..." allow-clear @search="handleSearch"
            @enter="handleSearch">
          </a-input-search>
          <div ref="sortRef" style="position:relative">
            <artmisads-select  v-model:value="sortValue" :getPopupContainer="() => $refs.sortRef"
              @change="(option) => setFilter('sort', option)">
              <a-select-option value="campaignNameAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Campaign Name </span>
              </a-select-option>
              <a-select-option value="campaignNameDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Campaign Name </span>
              </a-select-option>
              <!--  -->
              <a-select-option value="startDateAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Start Date </span>
              </a-select-option>
              <a-select-option value="startDateDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Start Date </span>
              </a-select-option>
              <!--  -->
              <a-select-option value="endDateAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> End Date </span>
              </a-select-option>
              <a-select-option value="endDateDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> End Date </span>
              </a-select-option>
              <!--  -->
               <a-select-option value="budgetAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Budget </span>
              </a-select-option>
              <a-select-option value="budgetDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Budget </span>
              </a-select-option>
              <!--  -->
              <!-- <a-select-option value="remainingBudgetAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Remaining Budget </span>
              </a-select-option>
              <a-select-option value="remainingBudgetDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px"> Remaining Budget </span>
              </a-select-option> -->
              <!--  -->
              <a-select-option value="commissionAsc" style="width: 180px">
                <svg class="icon" aria-hidden="true" style="transform: scaleY(-1)">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">  Commission </span>
              </a-select-option>
              <a-select-option value="commissionDesc" style="width: 180px">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-paixu1"></use>
                </svg>
                <span style="margin-left: 4px">  Commission </span>
              </a-select-option>
            </artmisads-select>
          </div>
        </a-space>
      </div>

      <div class="filters">
        <!-- <div class="filter-item">
          <div class="label">
            Marketplace:
          </div>
          <div class="brandBox" ref="brandRef">
            <artmisads-select class="width100" :options="marketplaceOptions" v-model:value="filter.marketplace"
              @select="(id, option) => setFilter('marketplace', option)" :getPopupContainer="() => $refs.brandRef" />
          </div>
        </div> -->
        <div class="filter-item">
          <div class="label">
            Status:
          </div>
          <div class="brandBox" ref="brandRef" style="position:relative">
            <artmisads-select  class="width100" :options="statusOptions" v-model:value="filter.campaignStatus"
              @select="(id, option) => setFilter('campaignStatus', option)"
              @clear="() => { filter.campaignStatus = ''; params.page = 1; getList() }"
              :getPopupContainer="() => $refs.brandRef" />
          </div>
        </div>
        <div class="filter-item">
          <div class="label">
            AcceptStatus:
          </div>
          <div class="brandBox" ref="brandRef" style="position:relative">
            <artmisads-select  class="width100" :options="acceptStatusOptions" v-model:value="filter.acceptStatus"
              @select="(id, option) => setFilter('acceptStatus', option)"
              @clear="() => { filter.acceptStatus = ''; params.page = 1; getList() }"
              :getPopupContainer="() => $refs.brandRef" />
          </div>
        </div>
        <div class="filter-item">
          <div class="label">
            Associate Partership Status:
          </div>
          <div class="brandBox" ref="brandRef" style="position:relative">
            <artmisads-select  class="width100" :options="associatePartnershipStatusOptions"
              v-model:value="filter.associatePartnershipStatus"
              @select="(id, option) => setFilter('associatePartnershipStatus', option)"
              @clear="() => { filter.associatePartnershipStatus = ''; params.page = 1; getList() }"
              :getPopupContainer="() => $refs.brandRef" />
          </div>
        </div>
      </div>
      <div class="table-content">
        <artmisads-table :loading="loading" :columns="columns" :data-source="dataSource" row-key="id" :pagination="{
          total: params.total,
          current: params.page,
          pageSize: params.size,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '50', '100', '200']
        }" :change="onChangePage" :scroll="{ x: 1600 }">
          <template #headerCell="{ column }">
            <template v-if="column.dataIndex === 'associatePartnershipDate'">
              <div class="flex-center">
                AssociatePartnership
                <a-popover >
                  <template #content>
                    <p style="margin-bottom: 20px;width: 550px;">If you have accepted the brand's ACC Campaign during
                      the authorized period of its Associate partnership with you, the commission for products in that
                      ACC Campaign will be adjusted according to the ACC commission policy. The specific rules are as
                      follows:</p>
                    <div class="popover-content">
                      <div class="popover-content-title">
                        Commission rate adjustment policy
                      </div>
                      <div class="popover-content-content">
                        <img class="imgA" :src="require('@/assets/images/img/ass.png')"
                          alt="Commission rate adjustment policy" />
                        <img class="equal" :src="require('@/assets/images/img/equal.png')"
                          alt="Commission rate adjustment policy" />
                        <img class="imgA" :src="require('@/assets/images/img/accI.png')"
                          alt="Commission rate adjustment policy" />
                      </div>
                      <div class="popover-content-text">
                        Associate commissions to publishers is not required. （commission = $0）
                      </div>
                      <div class="popover-content-content">
                        <img class="imgA" :src="require('@/assets/images/img/ass.png')"
                          alt="Commission rate adjustment policy" />
                        <img class="equal" :src="require('@/assets/images/img/greater.png')"
                          alt="Commission rate adjustment policy" />
                        <img class="imgA" :src="require('@/assets/images/img/accI.png')"
                          alt="Commission rate adjustment policy" />
                      </div>
                      <div class="popover-content-text" style="margin-bottom: 0;">
                        Only the difference is paid via ArtemisAds.
                      </div>
                    </div>
                  </template>
                  <Icon name="wenhao-tianchong" class="wenhao" />
                </a-popover>
              </div>

            </template>
          </template>
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'dates'">
              <div class="dates">
                <span class="date-label">Start:</span>
                <span class="date-item">{{ moment(record.startDateTimeInEpochMills).tz(timezone).format('YYYY-MM-DD')
                  }}</span>
              </div>
              <div class="dates">
                <span class="date-label">End:</span>
                <span class="date-item">{{ moment(record.endDateTimeInEpochMills).tz(timezone).format('YYYY-MM-DD')
                  }}</span>
              </div>
            </template>
            <template v-else-if="column.dataIndex === 'associatePartnershipDate'">
              {{ moment(record.associatePartnershipStartDateInEpochMills).tz(timezone).format('YYYY.MM.DD') }}-{{ moment(record.associatePartnershipEndDateInEpochMills).tz(timezone).format('YYYY.MM.DD')
              }}
            </template>
            <template v-else-if="column.dataIndex === 'budget'">
              {{ CURRENCY_DATA_MAPPER[record.currencyCode] }} {{ record.totalBudget }}
            </template>
            <template v-else-if="column.dataIndex === 'commission'">
              {{ record.commissionPercentage }}%
            </template>
            <template v-else-if="column.dataIndex === 'products'">
              <div class="item-count" @click="showProductsDrawer(record)">
                {{ record.productsCount }}
              </div>
            </template>
            <template v-else-if="column.dataIndex === 'status'">
              <Status :type="returnStatusType(record.campaignStatus)" :text="record.campaignStatus" />
            </template>
            <template v-else-if="column.dataIndex === 'action'">
              <Status :type="returnStatusType(record.acceptStatus)" :text="record.acceptStatus" :noBorder="true" />
              <!-- <artmisads-button type="primary" size="small" :isSquare="true" :disabled="record.acceptStatus == 'ACCEPTED'"
                @click="handleView(record)">{{ record.acceptStatus == 'ACCEPTED' ? 'Accepted' : 'Accept' }}</artmisads-button> -->
              <!-- <div class="flex-center">
                <a-button type="primary" size="small" @click="handleAcceptCampaign(record)">Accept</a-button>
                <a-button type="primary" size="small" @click="handleAcceptCampaign(record)">Accept</a-button>
              </div> -->
            </template>
          </template>
        </artmisads-table>
      </div>
    </div>
    <acceptCampaignModel ref="acceptCampaignModelRef" />
    <campaignsModal ref="campaignsModalRef" />

  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import breadcrumbs from "~/components/breadcrumbs.vue"
import ButtonGroups from '~/components/buttonGroups.vue'
import Icon from "@/components/Icon.vue"
import acceptCampaignModel from './components/acceptCampaignModel.vue'
import campaignsModal from './components/campaignsModal.vue'
import { associateCentralApi } from '~/server/index'
import moment from 'moment'
import { BILLING_TIME_TZ, CURRENCY_DATA_MAPPER } from '~/contants/common.js'
import Status from '@/components/Status.vue'
const acceptCampaignModelRef = ref(null)
const campaignsModalRef = ref(null)
const statusOptions = ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'DELIVERING',
    value: 'delivering',
  },
  {
    label: 'ENDED',
    value: 'ended',
  },
  {
    label: 'EXPIRED',
    value: 'expired',
  },
  {
    label: 'OUT OF BUDGET',
    value: 'out_of_budget',
  },
  {
    label: 'CREATED',
    value: 'created',
  },
  {
    label: 'DELETED',
    value: 'deleted',
  },
  {
    label: 'SCHEDULED',
    value: 'scheduled',
  },
  {
    label: 'ENDED_GRACE_PERIOD',
    value: 'ended_grace_period',
  }
])
const acceptStatusOptions = ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'ACCEPTED',
    value: 'accepted',
  },
  {
    label: 'NOT ACCEPTED',
    value: 'not_accepted',
  },
])
const associatePartnershipStatusOptions = ref([
  {
    label: 'All',
    value: '',
  },
  {
    label: 'ACTIVE',
    value: 'active',
  },
  {
    label: 'INACTIVE',
    value: 'inactive',
  },
])
const marketplaceOptions = ref([
  {
    label: 'amazon.com',
    value: 'amazon.com',
  },
  {
    label: 'amazon.co.uk',
    value: 'amazon.co.uk',
  },
  {
    label: 'amazon.de',
    value: 'amazon.de',
  },
  {
    label: 'amazon.ca',
    value: 'amazon.ca',
  },
  {
    label: 'amazon.fr',
    value: 'amazon.fr',
  },
])
const filter = ref({
  campaignStatus: '',
  acceptStatus: '',
  associatePartnershipStatus: '',
  keyword: '',
  sortField: 'campaignName',
  sortDirection: 'asc',
  // sort: '%2BbestSellers',
  marketplace: "amazon.com"
})
const timezone = BILLING_TIME_TZ[filter.value.marketplace]
const sortValue = ref('campaignNameAsc')
const params = ref({
  page: 1,
  size: 10,
  total: 0
})
const breadcrumbsData = ref({
  title: 'Campaigns',
  hasTitleIcon: true,
  color: "#9C7AFB",
  links: [
    {
      name: "Home",
      path: "/publisher/dashboard",
    },
    {
      name: "Associate Central",
      path: "/publisher/associateCentral/associateBrands",
    },
    {
      name: "All Campaigns",
      path: "/publisher/associateCentral/creatorConnections/allCampaigns",
    },
  ],
})
const showProductsDrawer = (record) => {
  campaignsModalRef.value.openModal('products', record.campaignId,filter.value.marketplace)
}
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
})
const brandOptions = ref([
  {
    label: 1,
    value: 'Brand 1',
  },
  {
    label: 2,
    value: 'Brand 2',
  },
])
const keyword = ref('')
const dataSource = ref([])
const loading = ref(false)
const columns = ref([
  {
    title: 'Campaign Name',
    dataIndex: 'campaignName',
    key: 'campaignName',
    width: 400,
  },
  {
    title: 'Brand',
    dataIndex: 'brandName',
    key: 'brandName',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Dates',
    dataIndex: 'dates',
    key: 'dates',
    width: 180,
  },
  {
    title: 'AssociatePartnership',
    dataIndex: 'associatePartnershipDate',
    key: 'associatePartnershipDate',
    width: 200,
  },
  {
    title: 'Budget',
    dataIndex: 'budget',
    key: 'budget',
    width: 150,
  },
  {
    title: 'Commission',
    dataIndex: 'commission',
    key: 'commission',
  },
  {
    title: 'Products',
    dataIndex: 'products',
    key: 'products',
  },
  // {
  //   title: 'Publishers',
  //   dataIndex: 'Publishers',
  //   key: 'Publishers',
  // },
  {
    title: 'Accept Status',
    dataIndex: 'action',
    key: 'action',
  }
])
const returnStatusType = (type) => {
  if (type == 'CREATED' || type == 'EXPIRED') {
    return 'inactive'
  } else if (type == 'DELIVERING') {
    return 'delivering'
  } else if (type == 'ENDED') {
    return 'active'
  } else if (type == 'OUTOFBUDGET') {
    return 'pending'
  } else if (type == 'DELETED') {
    return 'not_authorized'
  } else if(type=='ACCEPTED'){
    return 'active'
  } else if(type=='NOT_ACCEPTED'){
    return 'inactive'
  }
}
// Event handlers
const onPageChange = (page, pageSize) => {
  params.value.page = page
  getList()
}
const handleSearch = () => {
  filter.value.keyword = keyword.value
  params.value.page = 1
  getList()
}
const setFilter = (key, value) => {
  console.log(value,'value')
  if(key != 'sort'){
    filter.value[key] = value.value
    
  }else{
    if (value === 'campaignNameAsc') {
      filter.value.sortField = 'campaignName'
      filter.value.sortDirection = 'asc'
    }
    if (value === 'campaignNameDesc') {
      filter.value.sortField = 'campaignName'
      filter.value.sortDirection = 'desc'
    }
    if (value === 'startDateAsc') {
      filter.value.sortField = 'startDate'
      filter.value.sortDirection = 'asc'
    }
    if (value === 'startDateDesc') {
      filter.value.sortField = 'startDate'
      filter.value.sortDirection = 'desc'
    }
    if (value === 'endDateAsc') {
      filter.value.sortField = 'endDate'
      filter.value.sortDirection = 'asc'
    }
    if (value === 'endDateDesc') {
      filter.value.sortField = 'endDate'
      filter.value.sortDirection = 'desc'
    }
    if (value === 'commissionAsc') {
      filter.value.sortField = 'commission'
      filter.value.sortDirection = 'asc'
    }
    if (value === 'commissionDesc') {
      filter.value.sortField = 'commission'
      filter.value.sortDirection = 'desc'
    }
    if (value === 'budgetAsc') {
      filter.value.sortField = 'budget'
      filter.value.sortDirection = 'asc'
    }
    if (value === 'budgetDesc') {
      filter.value.sortField = 'budget'
      filter.value.sortDirection = 'desc'
    }
    if (value === 'remainingBudgetAsc') {
      filter.value.sortField = 'remainingBudget'
      filter.value.sortDirection = 'asc'
    }
    if (value === 'remainingBudgetDesc') {
      filter.value.sortField = 'remainingBudget'
      filter.value.sortDirection = 'desc'
    }
    
  }

  params.value.page = 1
  getList()
}
const onChangePage = (data) => {
  params.value.page = data.current
  params.value.size = data.pageSize
  getList()
}
const getList = () => {
  loading.value = true
  const param = {
    ...params.value,
    ...filter.value
  }

  associateCentralApi.getAssociateCampaignList(param).then(res => {
    dataSource.value = res.data.data || []
    params.value.total = res.data.total || 0
    // pagination.value.total = res.total || 0
  }).finally(() => {
    loading.value = false
  })
}
const handleView=(record)=>{
  acceptCampaignModelRef.value.open(record)
}
onMounted(() => {
  // setTimeout(() => {
  //   acceptCampaignModelRef.value.open()
  // }, 1000)
  getList()
})
</script>
<style scoped lang="less">
.item-count {
  text-decoration: underline;
  cursor: pointer;
}

.date-label {
  display: inline-block;
  width: 40px !important;
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.5);
}

.date-item {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.9);
  margin-left: 10px;
}

.width100 {
  width: 220px;
}

.dates {}

.wenhao {
  color: rgba(15, 6, 41, 0.3);
}

.popover-content-text {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 18px;
  letter-spacing: 0.3px;
  margin-top: 10px;
  margin-bottom: 24px;
}

.equal {
  // width: 5px;
  height: 8px;
  margin: 0 10px;
}

.imgA {
  height: 16px;
}

.content {
  padding: 20px;
  background-color: #fff;

  .table-head {
    display: flex;
    height: 64px;
    justify-content: space-between;
    align-items: center;


  }

  .filters {
    display: flex;
    gap: 22px;
    padding: 15px 16px;
    margin: 16px 0;
    border-radius: 8px;
    background: #F8F7FC;

    .filter-item {
      .label {
        color: #0f0629;
        font-family: "Sora";
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        opacity: 0.9;
        margin-bottom: 8px;
      }
    }
  }
}

.flex-center {
  display: flex;
  align-items: center;
  gap: 5px;
}

.popover-content {
  border-radius: 8px;
  background-color: rgba(248, 247, 252, 1);
  padding: 12px 16px;

  .popover-content-title {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0.3px;
    padding-bottom: 24px;
  }

}
.content-wrapper {
   display: block !important;
}
</style>